import React, { Dispatch, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import 'list-to-tree';
import 'array-to-tree';
import 'react-dropdown-tree-select/dist/styles.css'
import 'primereact/resources/themes/lara-light-blue/theme.css';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { Message } from 'primereact/message';
import { TabView, TabPanel } from 'primereact/tabview';
import * as Constants from "./Constants/ConstantValues";
import { Http, HttpEmail } from '../../utils/Http';
import { addCompanyDetails } from "../../store/actions/AddCorporate";
import '../../../src/css/style.css';
import InputEmployerData from "../../../src/assets/data/InputEmployerData.json";
import InputEmailTemplateData from "../../../src/assets/data/InputEmailTemplateData.json";
import '../../css/AddEmployer.css';
import '../../css/generalStyle.css';

interface IAddEmployer {
  dispatch: Dispatch<any>;
  companyData: any;
  companyId: any;
  fileFilterData: any;
  errorMessage: String;
  state: {
    nodes: [],
    checked: [],
    expanded: []
  }
}
const AddEmployer: React.FC<IAddEmployer> = ({

  dispatch, companyData, fileFilterData, errorMessage

}) => {
  useEffect(() => {

    Http.axios().get('api/getallCompanyAdditionalDetails')
      .then((e) => {

        setCompanies(e.data);

      })
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);
  const [isValid, setValid] = useState(true);
  let [isEmailValid, setEmailValid] = useState(true);
  const [isPasswordValid, setPasswordValid] = useState(true);
  const islengthValid = true;
  const isnameValid = true;
  const isregexValid = true;
  const [islengthcheckValid, setlengthcheckValid] = useState(true);
  const [isnamecheckValid, setnamecheckValid] = useState(true);
  const [isregexcheckValid, setregexcheckValid] = useState(true);
  const [isSumbmit, setSumbmited] = useState(false);
  let [companies, setCompanies] = useState<any | null>(null);

 


  const handlePageChange = (event: any) => {

    setSumbmited(true);
    inputFormData.roleId = Constants.SUPERADMINROLEID;
    setInput({ ...inputFormData });

    checkValidation();

    if (isValid && errorMessage === "") {



      dispatch(addCompanyDetails(inputFormData));

      InputEmailTemplateData.customerEmail = inputFormData.emailId;
      InputEmailTemplateData.employerName = inputFormData.employerName;
      InputEmailTemplateData.emailTemplate = "employer-setup.html";
      InputEmailTemplateData.userId = inputFormData.emailId;
      InputEmailTemplateData.password = inputFormData.password;
      InputEmailTemplateData.employerEmail = inputFormData.emailId;
      InputEmailTemplateData.passwordLink = "www.visacare.com";
      InputEmailTemplateData.subject = "Employer Account Creation at www.visacare.com ";
 

      HttpEmail.axios().post('/email/sendEmailTemplateWithAttachment', InputEmailTemplateData)
        .then((e) => {

        })

      alert("New Employer Added Successfully.");
      window.location.reload();
    } else {
      alert(errorMessage);
      setSumbmited(false);
    }

  }
  let [inputFormData, setInput] = useState(InputEmployerData);

 
  const [displayAddAtorney, setdisplayAddAtorney] = useState(false);


  const handleCreate = () => {
    window.location.href = "/visaCareAddNewAttorney";
  };

  const onFileChange = () => {

  }
  const onEmprH1bDependent = () => {
    if ((inputFormData.noOfEmployees <= 25 && inputFormData.noofH1bEmployees > 7)
      || (inputFormData.noOfEmployees > 25 && inputFormData.noOfEmployees <= 50 && inputFormData.noofH1bEmployees > 12)
      || (inputFormData.noOfEmployees > 50 && (inputFormData.noofH1bEmployees / inputFormData.noOfEmployees * 100) > 15)
    ) {
      inputFormData.isEmprH1bDependent = "Yes";
    } else {
      inputFormData.isEmprH1bDependent = "No";
    }
    if (inputFormData.noOfEmployees < 50) {
      inputFormData.morethan50perUS = false;
    } else {
      inputFormData.morethan50perUS = true;
      if ((inputFormData.noofH1bEmployees / inputFormData.noOfEmployees * 100) > 50) {
        inputFormData.morethan50perh1bl1a = true;
      } else {
        inputFormData.morethan50perh1bl1a = false;
      }
    }
  }
  const [isDispatchedSave, setIsDispatchedSave] = useState(true);
  const [isPageLoaded, setPageLoaded] = useState(false);

  if (!isPageLoaded && !companyData.isLoading) {
    if (companyData.items !== null) {
      if (companyData.items.dateOfIncor !== null && companyData.items.dateOfIncor !== "") {
        companyData.items.dateOfIncor = new Date(companyData.items.dateOfIncor);
      }
      companyData.items.employerName = companyData.items.employerName.toUpperCase();
      companyData.items.employerCode = companyData.items.employerCode.toUpperCase();
      companyData.items.signLastName = companyData.items.signLastName.toUpperCase();
      companyData.items.attnLastName = companyData.items.attnLastName.toUpperCase();
      companyData.items.attnFirstName = companyData.items.attnFirstName.charAt(0).toUpperCase() + companyData.items.attnFirstName.slice(1).toLowerCase();
      companyData.items.signFirstName = companyData.items.attnFirstName.charAt(0).toUpperCase() + companyData.items.attnFirstName.slice(1).toLowerCase();

      setInput(companyData.items);
    }
    setPageLoaded(true);
  }
  if (!companyData.isLoading && companyData.isFormSubmit && isDispatchedSave) {

    setIsDispatchedSave(false);
 
    setTimeout(() => {
      setPageLoaded(false);
    }, (1000));
  }

  const handleInputChange = (event: any) => {

    if (event.target.id === "employerName") {
      inputFormData.employerName = event.target.value.toUpperCase();
      inputFormData.employerCode = inputFormData.employerName.split(" ")[0];
 
    } else if (event.target.id === "emailId") {

      inputFormData.emailId = event.target.value;
      /*  */
    } else if (event.target.id === "password") {
      inputFormData.password = event.target.value;


    } else if (event.target.id === "confirmPassword") {
      inputFormData.confirmPassword = event.target.value;
    } else if (event.target.id === "streetName") {
      inputFormData.streetName = event.target.value;
    } else if (event.target.id === "aptSteFlr") {
      inputFormData.aptSteFlr = event.target.value;

    } else if (event.target.id === "aptSteFlrNumber") {
      inputFormData.aptSteFlrNumber = event.target.value;
    } else if (event.target.id === "city") {
      inputFormData.city = Constants.formatFirstName(event.target.value);
    } else if (event.target.id === "state") {
      inputFormData.state = event.target.value;
    } else if (event.target.id === "zipCode") {
      inputFormData.zipCode = event.target.value;
    } else if (event.target.id === "daytimePhoneNumber") {
      inputFormData.daytimePhoneNumber = Constants.formatPhoneNumber(event.target.value);
    } else if (event.target.id === "faxNumber") {
      inputFormData.faxNumber = Constants.formatPhoneNumber(event.target.value);
    } else if (event.target.id === "attnLastName") {
      inputFormData.attnLastName = event.target.value.toUpperCase();;
    } else if (event.target.id === "attnFirstName") {
      inputFormData.attnFirstName = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1).toLowerCase();
    } else if (event.target.id === "attnMiddleName") {
      inputFormData.attnMiddleName = event.target.value;
    } else if (event.target.id === "fein") {
      inputFormData.fein = event.target.value;
    } else if (event.target.id === "dateOfIncor") {
      inputFormData.dateOfIncor = event.target.value;
    } else if (event.target.id === "typeOfBusiness") {
      inputFormData.typeOfBusiness = event.target.value;
    } else if (event.target.id === "naicsCode") {
      inputFormData.naicsCode = event.target.value;
    } else if (event.target.id === "grossIncome") {
      inputFormData.grossIncome = event.target.value;
    } else if (event.target.id === "netIncome") {
      inputFormData.netIncome = event.target.value;
    } else if (event.target.id === "noOfEmployees") {
      inputFormData.noOfEmployees = event.target.value;
      onEmprH1bDependent();

    } else if (event.target.id === "noofH1bEmployees") {
      inputFormData.noofH1bEmployees = event.target.value;
      onEmprH1bDependent();

    } else if (event.target.id === "alternateEmailId") {
      inputFormData.alternateEmailId = event.target.value;
    } else if (event.target.id === "signLastName") {
      inputFormData.signLastName = event.target.value.toUpperCase();
    } else if (event.target.id === "signFirstName") {
      inputFormData.signFirstName = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1).toLowerCase();
    } else if (event.target.id === "signMiddleName") {
      inputFormData.signMiddleName = event.target.value;
    } else if (event.target.id === "aboutCompany") {
      inputFormData.aboutCompany = event.target.value;
    } else if (event.target.id === "isEmprViolator") {
      inputFormData.isEmprViolator = event.target.value;
    } else if (event.target.id === "isEmprH1bDependent") {
      inputFormData.isEmprH1bDependent = event.target.value;
    } else if (event.target.id === "isEmprAtorney") {
      inputFormData.isEmprAtorney = event.target.value;
    } else if (event.target.id === "signTitle") {
      inputFormData.signTitle = event.target.value;
    } else if (event.target.id === "nonprofitentity") {
      if (event.target.value === "Yes") {
        inputFormData.nonprofitentity = true;
      } else {
        inputFormData.nonprofitentity = false;
      }

    } else if (event.target.id === "secondaryeducationinstitution") {
      if (event.target.value === "Yes") {
        inputFormData.secondaryeducationinstitution = true;
      } else {
        inputFormData.secondaryeducationinstitution = false;
      }

    } else if (event.target.id === "correctusciserror") {
      if (event.target.value === "Yes") {
        inputFormData.correctusciserror = true;
      } else {
        inputFormData.correctusciserror = false;
      }

    } else if (event.target.id === "amendedpetition") {
      if (event.target.value === "Yes") {
        inputFormData.amendedpetition = true;
      } else {
        inputFormData.amendedpetition = false;
      }

    } else if (event.target.id === "subsequentrequestextension") {
      if (event.target.value === "Yes") {
        inputFormData.subsequentrequestextension = true;
      } else {
        inputFormData.subsequentrequestextension = false;
      }

    } else if (event.target.id === "nonprofitresearchorganization") {
      if (event.target.value === "Yes") {
        inputFormData.nonprofitresearchorganization = true;
      } else {
        inputFormData.nonprofitresearchorganization = false;
      }

    } else if (event.target.id === "nonprofitorganization") {
      if (event.target.value === "Yes") {
        inputFormData.nonprofitorganization = true;
      } else {
        inputFormData.nonprofitorganization = false;
      }

    } else if (event.target.id === "highereducationinstitution") {
      if (event.target.value === "Yes") {
        inputFormData.highereducationinstitution = true;
      } else {
        inputFormData.highereducationinstitution = false;
      }

    } else if (event.target.id === "morethan50perh1bl1a") {
      if (event.target.value === "Yes") {
        inputFormData.morethan50perh1bl1a = true;
      } else {
        inputFormData.morethan50perh1bl1a = false;
      }

    } else if (event.target.id === "morethan50perUS") {
      if (event.target.value === "Yes") {
        inputFormData.morethan50perUS = true;
      } else {
        inputFormData.morethan50perUS = false;
      }
    } else if (event.target.id === "willfulviolator") {
      if (event.target.value === "Yes") {
        inputFormData.willfulviolator = true;
      } else {
        inputFormData.willfulviolator = false;
      }

    } else if (event.target.id === "h1bdependent") {
      if (event.target.value === "Yes") {
        inputFormData.h1bdependent = true;
      } else {
        inputFormData.h1bdependent = false;
      }

    } else if (event.target.id === "subcriptionname") {
      inputFormData.subcriptionname = event.target.value;
    }

    if (inputFormData.isEmprAtorney === 'Yes') {
      setdisplayAddAtorney(true);
    } else {
      setdisplayAddAtorney(false);
    }

    setInput({ ...inputFormData });

  };

  const checkValidation = () => {
    errorMessage = "";

    setValid(true);

    if (!inputFormData.emailId.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i)) {
      setEmailValid(false);
      errorMessage = "Email Id Not a Valid Format ";

    }

    if (Object.keys(companies).length > 0) {

      fileFilterData = companies.filter(x => (x.emailId === inputFormData.emailId));

      if (fileFilterData.length > 0) {
        setEmailValid(false);
        if (errorMessage !== "") {
          errorMessage = errorMessage + " and Email Id Already Exist ";
        } else {
          errorMessage = "Email Id already exist ";
        }

      }
    }



    if (islengthValid) {

      if (inputFormData.password.length > 7) {
        setPasswordValid(true);
        setnamecheckValid(true);
        setregexcheckValid(true);
        setlengthcheckValid(true);
        if (isregexValid) {
          if (inputFormData.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[a-zA-Z\d@$!%*?&]{0,1000}$/i)) {
            setPasswordValid(true);
            setlengthcheckValid(true);

            if (isnameValid) {
              if (inputFormData.password === inputFormData.emailId) {
                setPasswordValid(false);
                setnamecheckValid(false);
                if (errorMessage !== "") {
                  errorMessage = errorMessage + " and Email Id and Password is Same ";
                } else {
                  errorMessage = "Email Id  and Password is Same ";
                }
              }
            }

          }
          else {
            setPasswordValid(false);
            setregexcheckValid(false);
            if (errorMessage !== "") {
              errorMessage = errorMessage + " and Password Policy error ";
            } else {
              errorMessage = "Password Policy error ";
            }
          }

        }
      } else {
        setPasswordValid(false);
        setlengthcheckValid(false);
        if (errorMessage !== "") {
          errorMessage = errorMessage + " and Password Policy error ";
        } else {
          errorMessage = "Password Policy error ";
        }
      }
    }
    else if (isregexValid) {
      if (inputFormData.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[a-zA-Z\d@$!%*?&]{0,1000}$/i)) {

      }
      else {
        setPasswordValid(false);
        setregexcheckValid(false);
        if (errorMessage !== "") {
          errorMessage = errorMessage + " and Password Policy error ";
        } else {
          errorMessage = "Password Policy error ";
        }
      }

    }
    else if (isnameValid) {
      if (inputFormData.password === inputFormData.emailId) {
        setPasswordValid(false);
        setnamecheckValid(false);
        if (errorMessage !== "") {
          errorMessage = errorMessage + " and Email Id and Password is Same ";
        } else {
          errorMessage = "Email Id  and Password is Same ";
        }
      }
    }


    if ((inputFormData.emailId !== null && inputFormData.emailId !== "" && isEmailValid)
      && (inputFormData.password === inputFormData.confirmPassword && inputFormData.password !== null && inputFormData.password !== "" && isPasswordValid)
      && (inputFormData.daytimePhoneNumber !== null && inputFormData.daytimePhoneNumber !== "")
      && (inputFormData.employerName !== null && inputFormData.employerName !== "")
      && (errorMessage === "")
    ) {
      setValid(true);
    }
    else {

      setValid(false);
    }
  
  }



  function requiredMessage(key: string) { return <Message severity="error" key={key} text="Field is required" /> }

  return (
    <div className="p-grid p-fluid">

      <div className="p-col-12">
        <div id="removePadding" className="p-col-12 p-md-12"></div>
        <div id="removePadding" className="p-col-12 p-md-12"> </div>
        <h4>Employer Profile</h4>
        <div className="card card-w-title no-border">
          <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
            <TabPanel header="Basic Details" >

              <div className="p-grid">

                <div id="removePadding" className="p-col-12 p-md-2">
                  <label htmlFor="cano">Employer Name<span className='important'>*</span></label>
                </div>
                <div id="removePadding" className="p-col-12 p-md-6">
                  <InputText id="employerName" name="employerName" value={inputFormData.employerName} required onChange={handleInputChange} />
                  {isSumbmit && inputFormData.employerName === "" && (requiredMessage("fn"))}
                </div>
                <div id="removePadding" className="p-col-12 p-md-2">
                  <label htmlFor="cano">SubCription<span className='important'>*</span></label>
                </div>
                <div id="removePadding" className="p-col-12 p-md-2">
                  <select id="subcriptionname"
                    value={inputFormData.subcriptionname}
                    onChange={handleInputChange}
                  >
                    <option value="">-Select-</option>
                    <option value="SILVER">SILVER</option>
                    <option value="GOLD">GOLD</option>
                    <option value="PLATINUM">PLATINUM</option>
                  </select>
                </div>

                <div id="removePadding" className="p-col-12 p-md-4">
                  Email Address<span className='important'>*</span>
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  Password<span className='important'>*</span>
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  Confirm Password<span className='important'>*</span>
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="emailId" name="emailId" onChange={handleInputChange} value={inputFormData.emailId} required  />
                  {isSumbmit && inputFormData.emailId === "" && (requiredMessage("fn"))}
                  {isSumbmit && !isEmailValid && (<Message severity="error" key="useridvalid" text="Email Id is not valid or already emailid exist " />)}

                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText type='password' id="password" value={inputFormData.password} required onChange={handleInputChange} />
                  {isSumbmit && inputFormData.password === "" && (requiredMessage("pas"))}
                  {isSumbmit && !isnamecheckValid && (<Message severity="error" key="namecheckvalid" text="password and user name should be diffrent " />)}
                  {isSumbmit && !isregexcheckValid && (<Message severity="error" key="regexcheckvalid" text="password should have one upper case one lower caser one number and one special character  " />)}
                  {isSumbmit && !islengthcheckValid && (<Message severity="error" key="lengthcheckvalid" text="password should be 8 characters  " />)}

                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText type='password' id="confirmPassword" value={inputFormData.confirmPassword} required onChange={handleInputChange} />
                  {isSumbmit && inputFormData.confirmPassword === "" && (requiredMessage("cpas"))}
                  {isSumbmit && inputFormData.confirmPassword !== inputFormData.password && (<Message severity="error" key="emailvalid" text="Password not matched" />)}

                </div>

                <div id="removePadding" className="p-col-12 p-md-4">
                  Daytime Telephone Number<span className='important'>*</span>
                </div>

                <div id="removePadding" className="p-col-12 p-md-4">
                  Fax Number (if any)
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  Email Address
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="daytimePhoneNumber" onChange={handleInputChange} value={inputFormData.daytimePhoneNumber} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="faxNumber" onChange={handleInputChange} value={inputFormData.faxNumber} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="emailId1" onChange={handleInputChange} value={inputFormData.emailId} required  />

                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  Street Number and Name
                </div>

                <div id="removePadding" className="p-col-12 p-md-1">

                </div>
                <div id="removePadding" className="p-col-12 p-md-1 inline-display" >
                  Apt
                </div>
                <div id="removePadding" className="p-col-12 p-md-1 inline-display" >
                  Ste
                </div>
                <div id="removePadding" className="p-col-12 p-md-1 inline-display" >
                  Flr
                </div>


                <div id="removePadding" className="p-col-12 p-md-4">
                  Number
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="aptSteFlr" onChange={handleInputChange} value={inputFormData.aptSteFlr} required  />
                </div>

                <div id="removePadding" className="p-col-12 p-md-1">

                </div>

                <div id="removePadding" className="p-col-12 p-md-1 inline-display" >
                  <Checkbox id="aptSteFlr" name="option" checked={inputFormData.aptSteFlr === "APT"} value="APT" onChange={handleInputChange} />
                </div>
                <div id="removePadding" className="p-col-12 p-md-1 inline-display" >
                  <Checkbox id="aptSteFlr" name="option" checked={inputFormData.aptSteFlr === "STE"} value="STE" onChange={handleInputChange} />
                </div>
                <div id="removePadding" className="p-col-12 p-md-1 inline-display" >
                  <Checkbox id="aptSteFlr" name="option" checked={inputFormData.aptSteFlr === "FLR"} value="FLR" onChange={handleInputChange} />
                </div>


                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="aptSteFlrNumber" onChange={handleInputChange} value={inputFormData.aptSteFlrNumber} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  City or Town
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  State
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  ZIP Code
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="city" onChange={handleInputChange} value={inputFormData.city} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="state" onChange={handleInputChange} value={inputFormData.state} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="zipCode" onChange={handleInputChange} value={inputFormData.zipCode} required  />
                </div>


                <div id="removePadding" className="p-col-12 p-md-4">
                  Attn -  Family Name (Last Name)
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  Attn -  Given Name (First Name)
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  Attn -   Middle Name
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="attnLastName" onChange={handleInputChange} value={inputFormData.attnLastName} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="attnFirstName" onChange={handleInputChange} value={inputFormData.attnFirstName} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="attnMiddleName" onChange={handleInputChange} value={inputFormData.attnMiddleName} required  />
                </div>


                <div id="removePadding" className="p-col-12 p-md-2">

                </div>
                <div id="removePadding" className="p-col-12 p-md-4">

                </div>
                <div id="removePadding" className="p-col-12 p-md-2">

                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <a onClick={() => setActiveIndex(1)} className='absolute-left-90'> Next </a>
                </div>
              </div>




            </TabPanel >


            <TabPanel header="Additional Details" >

              <div className="p-grid">

                <div id="removePadding" className="p-col-12 p-md-4">
                  FEIN
                </div>

                <div id="removePadding" className="p-col-12 p-md-4">
                  Date of Incorporation
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  Type of Business
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="fein" onChange={handleInputChange} value={inputFormData.fein} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-3">

                  <Calendar value={inputFormData.dateOfIncor} placeholder="MM-DD-YYYY" viewDate={inputFormData.dateOfIncor} name="dateOfIncor" id="dateOfIncor" dateFormat={Constants.USCALDATEFORMAT} onChange={handleInputChange} showIcon={true} />

                </div> <div id="removePadding" className="p-col-12 p-md-1"></div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="typeOfBusiness" onChange={handleInputChange} value={inputFormData.typeOfBusiness} required  />
                </div>

                <div id="removePadding" className="p-col-12 p-md-4">
                  NAICS Code
                </div>

                <div id="removePadding" className="p-col-12 p-md-4">
                  Gross Income
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  Net Income
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="naicsCode" onChange={handleInputChange} value={inputFormData.naicsCode} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="grossIncome" onChange={handleInputChange} value={inputFormData.grossIncome} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="netIncome" onChange={handleInputChange} value={inputFormData.netIncome} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  # of Employees
                </div>

                <div id="removePadding" className="p-col-12 p-md-4">
                  # of H1B Employees
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  Alternate Email Id
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="noOfEmployees" onChange={handleInputChange} value={inputFormData.noOfEmployees} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="noofH1bEmployees" onChange={handleInputChange} value={inputFormData.noofH1bEmployees} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="alternateEmailId" onChange={handleInputChange} value={inputFormData.alternateEmailId} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  Who Sign -  Family Name (Last Name)
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  Who Sign -  Given Name (First Name)
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  Who Sign -   Middle Name
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="signLastName" onChange={handleInputChange} value={inputFormData.signLastName} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="signFirstName" onChange={handleInputChange} value={inputFormData.signFirstName} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="signMiddleName" onChange={handleInputChange} value={inputFormData.signMiddleName} required  />
                </div>

                <div id="removePadding" className="p-col-12 p-md-4">
                  Who Sign - Title
                </div>

                <div id="removePadding" className="p-col-12 p-md-4">
                  Sample Sign Upload
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">

                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <InputText id="signTitle" onChange={handleInputChange} value={inputFormData.signTitle} required  />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">
                  <input type="file" onChange={onFileChange} />
                </div>
                <div id="removePadding" className="p-col-12 p-md-4">

                </div>
                <div id="removePadding" className="p-col-12 p-md-12">
                  About Company
                </div>
                <div id="removePadding" className="p-col-12 p-md-12">
                  <InputTextarea maxLength={3500} id="aboutCompany"
                    aria-multiline
                    inputMode="outlined"
                    value={inputFormData.aboutCompany}
                    onChange={(handleInputChange)}
                    required />
                </div>
                <div id="removePadding" className="p-col-12 p-md-3">
                  Is Employer H1B Dependent
                </div>
                <div id="removePadding" className="p-col-12 p-md-3">
                  Is Employer willfull Violator
                </div>


                <div id="removePadding" className="p-col-12 p-md-6">
                  Do you have In-House Attorney?   </div>

                <div id="removePadding" className="p-col-12 p-md-3">

                  <select id="isEmprH1bDependent"
                    value={inputFormData.isEmprH1bDependent}>
                    <option value="">-Select-</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>



                </div>
                <div id="removePadding" className="p-col-12 p-md-3">
                  <select id="isEmprViolator"
                    value={inputFormData.isEmprViolator}
                    onChange={handleInputChange}
                  >
                    <option value="">-Select-</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>

                </div>



                <div id="removePadding" className="p-col-12 p-md-3">
                  <select id="isEmprAtorney"
                    value={inputFormData.isEmprAtorney}
                    onChange={handleInputChange}
                  >
                    <option value="">-Select-</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  {(displayAddAtorney &&
                    <div id="removePadding" className="p-col-12 p-md-3"><Button
                      className="inline-end-float"
                      label="Add Attorney"
                      icon="pi pi-plus"
                      onClick={handleCreate}
                    /></div>
                  )}
                  {(!displayAddAtorney &&
                    <div id="removePadding" className="p-col-12 p-md-3"></div>
                  )}

                </div>
              </div>



            </TabPanel>
            <TabPanel header="H1B-Question Details" >

              <div className="p-grid">
                <div id="removePadding" className="p-col-12 p-md-10">
                  1. Does the petitioner employ 50 or more individuals in the United States? ?  (we must select value from employer profile section)
                </div>
                <div id="removePadding" className="p-col-12 p-md-2">
                  <Checkbox id="morethan50perUS" name="morethan50perUS" checked={inputFormData.morethan50perUS} value={"Yes"} onChange={handleInputChange} readOnly={true} /> Yes
                  <Checkbox id="morethan50perUS" name="morethan50perUS" checked={!inputFormData.morethan50perUS} value={"No"} onChange={handleInputChange} readOnly={true} /> No


                </div>

                <div id="removePadding" className="p-col-12 p-md-10">
                  <b>2. </b>If yes, are more than 50 percent of those employees in H-1B, L-1A, or L-1B nonimmigrant. ?  (we must select value from employer profile section)
                </div>
                <div id="removePadding" className="p-col-12 p-md-2">
                  <Checkbox id="morethan50perh1bl1a" name="morethan50perh1bl1a" checked={inputFormData.morethan50perh1bl1a} value={"Yes"} onChange={handleInputChange} readOnly={true} /> Yes
                  <Checkbox id="morethan50perh1bl1a" name="morethan50perh1bl1a" checked={!inputFormData.morethan50perh1bl1a} value={"No"} onChange={handleInputChange} readOnly={true} /> No

                </div>

                <div id="removePadding" className="p-col-12 p-md-10">
                  3.	Are you an institution of higher education as defined in section 101(a) of the Higher Education Act of 1965, 20 U.S.C. 1001(a)?

                </div>
                <div id="removePadding" className="p-col-12 p-md-2">
                  <Checkbox id="highereducationinstitution" name="highereducationinstitution" checked={inputFormData.highereducationinstitution} value={"Yes"} onChange={handleInputChange} /> Yes
                  <Checkbox id="highereducationinstitution" name="highereducationinstitution" checked={!inputFormData.highereducationinstitution} value={"No"} onChange={handleInputChange} /> No


                </div>

                <div id="removePadding" className="p-col-12 p-md-10">
                  4.	Are you a nonprofit organization or entity related to or affiliated with an institution of higher education, as defined in 8 CFR 214.2(h)(19)(iii)(B)?

                </div>
                <div id="removePadding" className="p-col-12 p-md-2">
                  <Checkbox id="nonprofitorganization" name="nonprofitorganization" checked={inputFormData.nonprofitorganization} value={"Yes"} onChange={handleInputChange} /> Yes
                  <Checkbox id="nonprofitorganization" name="nonprofitorganization" checked={!inputFormData.nonprofitorganization} value={"No"} onChange={handleInputChange} /> No

                </div>

                <div id="removePadding" className="p-col-12 p-md-10">
                  5.	Are you a nonprofit research organization or a governmental research organization, as defined in 8 CFR 214.2(h)(19)(iii)(C)?

                </div>
                <div id="removePadding" className="p-col-12 p-md-2">
                  <Checkbox id="nonprofitresearchorganization" name="nonprofitresearchorganization" checked={inputFormData.nonprofitresearchorganization} value={"Yes"} onChange={handleInputChange} /> Yes
                  <Checkbox id="nonprofitresearchorganization" name="nonprofitresearchorganization" checked={!inputFormData.nonprofitresearchorganization} value={"No"} onChange={handleInputChange} /> No


                </div>

                <div id="removePadding" className="p-col-12 p-md-10">
                  6.	Is this the second or subsequent request for an extension of stay that this petitioner has filed for this alien?

                </div>
                <div id="removePadding" className="p-col-12 p-md-2">
                  <Checkbox id="subsequentrequestextension" name="subsequentrequestextension" checked={inputFormData.subsequentrequestextension} value={"Yes"} onChange={handleInputChange} /> Yes
                  <Checkbox id="subsequentrequestextension" name="subsequentrequestextension" checked={!inputFormData.subsequentrequestextension} value={"No"} onChange={handleInputChange} /> No


                </div>

                <div id="removePadding" className="p-col-12 p-md-10">
                  7.	Is this an amended petition that does not contain any request for extensions of stay?

                </div>
                <div id="removePadding" className="p-col-12 p-md-2">
                  <Checkbox id="amendedpetition" name="amendedpetition" checked={inputFormData.amendedpetition} value={"Yes"} onChange={handleInputChange} /> Yes
                  <Checkbox id="amendedpetition" name="amendedpetition" checked={!inputFormData.amendedpetition} value={"No"} onChange={handleInputChange} /> No

                </div>


                <div id="removePadding" className="p-col-12 p-md-10">
                  8.	Are you filing this petition to correct a USCIS error?

                </div>
                <div id="removePadding" className="p-col-12 p-md-2">
                  <Checkbox id="correctusciserror" name="correctusciserror" checked={inputFormData.correctusciserror} value={"Yes"} onChange={handleInputChange} /> Yes
                  <Checkbox id="correctusciserror" name="correctusciserror" checked={!inputFormData.correctusciserror} value={"No"} onChange={handleInputChange} /> No


                </div>


                <div id="removePadding" className="p-col-12 p-md-10">
                  9.	Is the petitioner a primary or secondary education institution?
                </div>
                <div id="removePadding" className="p-col-12 p-md-2">
                  <Checkbox id="secondaryeducationinstitution" name="secondaryeducationinstitution" checked={inputFormData.secondaryeducationinstitution} value={"Yes"} onChange={handleInputChange} /> Yes
                  <Checkbox id="secondaryeducationinstitution" name="secondaryeducationinstitution" checked={!inputFormData.secondaryeducationinstitution} value={"No"} onChange={handleInputChange} /> No


                </div>


                <div id="removePadding" className="p-col-12 p-md-10">
                  10.	Is the petitioner a nonprofit entity that engages in an established curriculum-related clinical training of students registered at such an institution?
                </div>
                <div id="removePadding" className="p-col-12 p-md-2">
                  <Checkbox id="nonprofitentity" name="nonprofitentity" checked={inputFormData.nonprofitentity} value={"Yes"} onChange={handleInputChange} /> Yes
                  <Checkbox id="nonprofitentity" name="nonprofitentity" checked={!inputFormData.nonprofitentity} value={"No"} onChange={handleInputChange} /> No


                </div>


              </div>




            </TabPanel>
          </TabView>
          <div className="p-grid" >

            <div id="removePadding" className="p-col-12 p-md-4">
            </div>
            <div id="removePadding" className="p-col-12 p-md-2">
              {!isSumbmit &&
                <Button icon="pi pi-save" label="Save" onClick={handlePageChange} className='width-120' />
              }
            </div>
            <div id="removePadding" className="p-col-12 p-md-2">

            </div>

            <div id="removePadding" className="p-col-12 p-md-4">



            </div>
          </div>

        </div>

      </div>


    </div>


  );


};
const mapStateToProps = (state: any) => {
  const { deviceFormData } = state;
  const { companyData } = state;
  const { aapermissionsData } = state;
  const { AaapermissionData } = state;
  const {
    COMMONTYPEData,
    COMMONCATEGORYData,
    INSTALLATIONTYPEData,
    INSTALLATIONSUBTYPEData
  } = state;
  const { items } = state;
  return {
    deviceFormData,

    companyData,
    aapermissionsData,
    AaapermissionData,

    COMMONTYPEData,
    COMMONCATEGORYData,
    INSTALLATIONTYPEData,
    INSTALLATIONSUBTYPEData,
    items
  };
};
export default connect(mapStateToProps)(AddEmployer);
